"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logSentryEvent = logSentryEvent;
exports.logBlik = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Sentry = _interopRequireWildcard(require("@sentry/nextjs"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function logSentryEvent(_ref) {
  var eventType = _ref.eventType,
    eventName = _ref.eventName,
    contextTag = _ref.contextTag,
    _ref$contextData = _ref.contextData,
    contextData = _ref$contextData === void 0 ? {} : _ref$contextData,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? "info" : _ref$level;
  try {
    Sentry.setTag("payment_method", contextTag);
    if (contextData && Object.keys(contextData).length > 0) {
      Sentry.setContext("".concat(contextTag, "_").concat(eventName), contextData);
    }
    if (eventType === "message") {
      Sentry.captureMessage("".concat(contextTag.toUpperCase(), ": ").concat(eventName), level);
    } else if (eventType === "exception") {
      Sentry.captureException(_objectSpread({
        contextTag: contextTag,
        eventName: eventName
      }, contextData));
    } else if (eventType === "error" && contextData.error) {
      Sentry.captureException(contextData.error);
    }
  } catch (err) {
    console.warn("Failed to log to Sentry:", err);
  }
}
var logBlik = function logBlik(params) {
  return logSentryEvent(_objectSpread(_objectSpread({}, params), {}, {
    contextTag: "blik"
  }));
};
exports.logBlik = logBlik;